export default "__VITE_PUBLIC_ASSET__3cea65a2__"